export default "__VITE_ASSET__d68411a1__"